module.exports = __webpack_public_path__ + "img/logo-main-en.2096dc96.png";